module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/graduate-2271de1ad86f0ccdfbf2192620c16a0c.svg";